var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('figure',{staticClass:"image is-16by9"},[_c('iframe',{staticClass:"has-ratio",attrs:{"width":"640","height":"360","src":("https://www.youtube.com/embed/" + _vm.vidId),"frameborder":"0","allowfullscreen":""}})])}
var staticRenderFns = []

export { render, staticRenderFns }